import {NgModule} from "@angular/core"
import {MatMomentDateModule} from "@angular/material-moment-adapter"
import {MatDatepickerModule} from "@angular/material"
import {DatePickerFormatProvider} from "app/common/material/date-picker/DatePickerDefaults"

@NgModule({
    imports: [
        MatDatepickerModule,
        MatMomentDateModule
    ],
    exports: [
        MatDatepickerModule
    ],
    providers: [
        DatePickerFormatProvider
    ]
})
export class DatePickerModule {

}
